import React from 'react';
import { getdate, formatdate, updatedata, deletedata } from "../../util/global"; //

const PatientView = ({ mode, setmode, formdata, filedata = [], appointmentdata, prescriptiondata, fetchdata, intakeformdata}) => {

  if (mode !== "viewpatient") return null; 

  const handledelete = async (fileid) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;
    const payload = {filter: {_id: fileid,datatype: "filedata", dbcollection: "appfiledata"}}

    const result = await deletedata(payload); 
    if (result.deletedcount > 0) {
      alert("File deleted successfully. ");
      fetchdata();
    } else {
      alert("Failed to delete file.");
    }
  };
  const handledeletesysprescription = async (presciptionid) => {
    if (!window.confirm("Are you sure you want to delete this prescription ?")) return;
    const payload = {filter: {_id: presciptionid,datatype: "prescriptiondata"}}

    const result = await deletedata(payload); 
    if (result.deletedcount > 0) {
      alert( "deleted successfully. ");
      fetchdata();
    } else {
      alert("failed to delete.");
    }
  };

  const handledeleteintakeform = async (presciptionid) => {
    if (!window.confirm("Are you sure you want to delete this intakeform ?")) return;
    const payload = {filter: {_id: presciptionid,datatype: "intakeformdata"}}

    const result = await deletedata(payload); 
    if (result.deletedcount > 0) {
      alert( "deleted successfully. ");
      fetchdata();
    } else {
      alert("failed to delete.");
    }
  };
 
  return (
    <div className="modal-overlay"> {/*[cite: 6] */}
      <div className="modal-content" style={{ width: '800px', maxHeight: '90vh', overflowY: 'auto' }}> {/*[cite: 6] */}
        <div className="modal-header">
          <h3>patient details</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button> {/*[cite: 6] */}
        </div>
        
        <div id="printarea" style={{ padding: '20px' }}> {/*[cite: 6] */}
          {/* Header Section: Photo & Basic Info */}
          <table style={{ border: 'none', marginBottom: '30px' }}> {/*[cite: 6] */}
            <tbody>
              <tr>
                <td style={{ width: '120px', border: 'none' }}> {/*[cite: 6] */}
                  <div style={{ width: '100px', height: '100px', backgroundColor: '#eee', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}> {/*[cite: 6] */}
                    Photo
                  </div>
                </td>
                <td style={{ border: 'none', verticalAlign: 'top' }}> {/*[cite: 6] */}
                  <h2 style={{ margin: '0 0 10px 0' }}>{formdata.name}</h2> {/*[cite: 6] */}
                  <p style={{ margin: '0' }}><strong>Phone:</strong> {formdata.phonenumber}</p> {/*[cite: 6] */}
                  <p style={{ margin: '0' }}><strong>Patient ID:</strong> {formdata._id}</p> {/*[cite: 6] */}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Intake Form Section */}
          <h3>Intake Form</h3> {/*[cite: 6] */}
          <table className="grid"> {/*[cite: 6] */}
            <thead>
              <tr>
                <th style={{ width: '40px', textAlign: 'center' }}></th>
                <th>Date</th>
                <th>Description</th>
                <th style={{ width: '60px', textAlign: 'center' }}></th>
              </tr>
            </thead>
            <tbody>
              {intakeformdata.map((a, i) => ( //[cite: 6]
                <tr key={a._id || i}>
                  <td style={{ textAlign: 'center' }}>
                    <button 
                      onClick={() => handledeleteintakeform(a._id)}
                      style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      x
                    </button>
                  </td>
                  <td>{a.updatetimestamp ? formatdate(new Date(a.updatetimestamp)) : "-"}</td> {/*[cite: 6] */}
                  <td>{a.formtype}</td> {/*[cite: 6] */}
                  <td style={{ textAlign: 'center' }}>
                    <a 
                      href={`/intakeformview?intakeformid=${a._id}`} 
                      target="_blank" //[cite: 6]
                      rel="noopener noreferrer" //[cite: 6]
                    >
                      view
                    </a>
                  </td>
                </tr>
              ))}

              {filedata.filter(item => item.filetype === "intakeform").map((a, i) => ( //[cite: 6]
                <tr key={a._id || i}>
                  <td style={{ textAlign: 'center' }}>
                    <button 
                      onClick={() => handledelete(a._id)}
                      style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      x
                    </button>
                  </td>
                  <td>{a.uploaddate ? formatdate(new Date(a.uploaddate)) : "-"}</td> {/*[cite: 6] */}
                  <td>{a.displayname || a.filename}</td> {/*[cite: 6] */}
                  <td style={{ textAlign: 'center' }}>
                    <a 
                      href={`/file?_fileid=${a._id}&_userid=${window.APPUSER?.user?.userid || ''}&_adminuserid=${window.APPSETTING?.adminuserid || ''}`} //[cite: 6]
                      target="_blank" //[cite: 6]
                      rel="noopener noreferrer" //[cite: 6]
                    >
                      view
                    </a>
                  </td>
                </tr>
              ))}
              {filedata.filter(item => item.filetype === "intakeform").length === 0 && (
                <tr><td colSpan="4" style={{ textAlign: 'center', color: '#999' }}>No intake forms uploaded.</td></tr>
              )}
            </tbody>
          </table>

          {/* Prescription Section */}
          <h3>Prescription History</h3> {/*[cite: 6] */}
          <table className="grid"> {/*[cite: 6] */}
            <thead>
              <tr>
                <th style={{ width: '40px', textAlign: 'center' }}></th>
                <th>Date</th>
                <th>Description</th>
                <th style={{ width: '60px', textAlign: 'center' }}></th>
              </tr>
            </thead>
            <tbody>

              {prescriptiondata.map((a, i) => (
                <tr key={a._id || i}>
                  <td style={{ textAlign: 'center' }}>
                    <button
                      onClick={() => handledeletesysprescription(a._id)}
                      style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      x
                    </button>
                  </td>
                  <td>{a.datetime}</td>
                  <td>
                    {a.medicinedata?.map(med => med.medicine).join(', ')}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <a
                      href={`/prescriptionview?prescriptionid=${a._id}&appname=${window.APPSETTING?.appname || ''}&adminuserid=${window.APPSETTING?.adminuserid || ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      view
                    </a>
                  </td>
                </tr>
              ))}

              {filedata.filter(item => item.filetype === "prescription").map((a, i) => (
                <tr key={a._id || i}>
                  <td style={{ textAlign: 'center' }}>
                    <button 
                      onClick={() => handledelete(a._id)}
                      style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      x
                    </button>
                  </td>
                  <td>{a.uploaddate ? formatdate(new Date(a.uploaddate)) : "-"}</td>
                  <td>{a.displayname || a.filename}</td>
                  <td style={{ textAlign: 'center' }}>
                    <a 
                      href={`/file?_fileid=${a._id}&_userid=${window.APPUSER?.user?.userid || ''}&_adminuserid=${window.APPSETTING?.adminuserid || ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      view
                    </a>
                  </td>
                </tr>
              ))}
              {filedata.filter(item => item.filetype === "prescription").length === 0 && (
                <tr><td colSpan="4" style={{ textAlign: 'center', color: '#999' }}>No prescriptions uploaded.</td></tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default PatientView; 